import { Link } from "react-router-dom";
import { hotVideos } from "@/mocks/videos";
import VideoCard from "@/components/feature/VideoCard";

export default function HotVideos() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-6 w-1.5 rounded-full bg-primary-500"></span>
            <h2 className="text-xl font-black text-foreground-950 md:text-2xl">热门视频推荐</h2>
          </div>
          <p className="mt-2 text-sm text-foreground-500">正在被最多人观看的高人气内容</p>
        </div>
        <Link
          to="/category/movie?sort=hot"
          className="hidden cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 sm:flex"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-5 lg:grid-cols-6">
        {hotVideos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}